import { useSelector } from 'react-redux';
import { CURRENCIES } from '../../server/helpers/constants.mjs';

const useCurrency = () => {
  const currentCurCode = useSelector((state) => state.profile.currency);
  return CURRENCIES[currentCurCode] ? CURRENCIES[currentCurCode] : '';
};

export default useCurrency;
